<template>
  <div
    class="d-flex align-items-center justify-content-between px-12 border-bottom"
    style="height: 56px">
    <!-- <div class="d-flex">
      <img src="/assets/icon/Star.svg" />
      <span class="ms-2 font-14 text-grey600">Giao diện hiện tại đã được nâng cấp! Bạn có thể chuyển đổi giữa 2 phiên bản bất kì lúc nào.</span>
    </div> -->
    <div
      class="z2-btn-info d-flex align-items-center font-14 fw-500 px-2 py-1 rounded-2"
      @click="changeVersion">
      <IconV2
        class="me-1"
        name="v2-change" />
      Chuyển giao diện {{ currentVersion === "old" ? "mới" : "cũ" }}
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      currentVersion: localStorage.getItem("versionUI"),
    };
  },
  methods: {
    changeVersion() {
      if (!this.currentVersion || this.currentVersion === "old") {
        localStorage.setItem("versionUI", "new");
      }
      if (this.currentVersion === "new") {
        localStorage.setItem("versionUI", "old");
      }
      location.reload();
    },
  },
};
</script>

<style>
</style>